// extracted by mini-css-extract-plugin
export default {"page":"Partner_page__ut8XE"};